export const ADD_DISHES = 'ADD_DISHES'
